module.exports = __webpack_public_path__ + "img/House6-mobile.999cce45.jpg";